import React from "react";
const SendMailIcon = (props) => {
  return (
    <svg
      style={{ marginRight: 5 }}
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49955 3.25906C0.748067 3.74038 0.25 4.5827 0.25 5.54134V10.5413C0.25 12.9576 2.20876 14.9163 4.625 14.9163H12.125C13.0837 14.9163 13.926 14.4183 14.4073 13.6668L4.625 13.6663C2.89911 13.6663 1.5 12.2673 1.5 10.5413L1.49955 3.25906ZM14.625 0.333008H5.04167C3.59748 0.333008 2.41729 1.46338 2.33762 2.88766L2.33333 3.04134V10.1247C2.33333 11.5688 3.46371 12.749 4.88798 12.8288L5.04167 12.833H14.625C16.0692 12.833 17.2493 11.7026 17.3291 10.2783L17.3333 10.1247V3.04134C17.3333 1.59715 16.2029 0.416966 14.7787 0.337291L14.625 0.333008ZM3.58333 4.41551L9.54225 7.55276C9.69842 7.63492 9.88075 7.64667 10.0443 7.58801L10.1244 7.55276L16.0833 4.41634V10.1247C16.0833 10.8898 15.4941 11.5173 14.7446 11.5782L14.625 11.583H5.04167C4.27653 11.583 3.64901 10.9938 3.58817 10.2443L3.58333 10.1247V4.41551ZM5.04167 1.58301H14.625C15.3902 1.58301 16.0177 2.17227 16.0785 2.92173L16.0817 3.00467L9.83333 6.29342L3.58381 3.0037C3.60378 2.21568 4.24883 1.58301 5.04167 1.58301Z"
        fill="#0358A7"
      />
    </svg>
  );
};

export default SendMailIcon;
